import React from 'react';
import DraftImage from '../../../assets/icons/draft.png';
import { PROJECT_NAME_MAX_LENGTH } from '../../../utils/inputLimits';

import styles from '../ManagePage.module.css';

const SingleProjectCard = ({
  generation,
  cardImage,
  currentProjectName,
  isEditing,
  isDraft,
  isSelected,
  listingMode,
  editingProjectName,
  newProjectName,
  setNewProjectName,
  onSaveProjectName,
  onCancelEdit,
  onStartEdit,
  onCardClick,
  onSelectionChange,
  isSelectionMode,
  formatDate
}) => {
  const generationId = generation._id;

  return (
    <div 
      key={`all-${generationId}`}
      className={`${styles.generationCard} ${isDraft ? styles.draftCard : ''} ${isSelected ? styles.selectedCard : ''} ${isSelectionMode ? styles.selectionMode : ''} ${isEditing ? styles.cardEditingName : ''}`}
      onClick={!isSelectionMode && !isEditing ? onCardClick : undefined}
    >
      {isSelectionMode && (
        <div className={styles.cardSelection}>
          <input
            type="checkbox"
            checked={isSelected}
            onChange={(e) => {
              e.stopPropagation();
              onSelectionChange(generationId, e.target.checked);
            }}
            className={styles.projectCheckbox}
          />
        </div>
      )}
      
      <div className={styles.recentProjectInner}>
        <div className={styles.cardImage}>
          {isDraft ? (
            <div className={styles.draftPlaceholder}>
              <img src={DraftImage} alt="" />
            </div>
          ) : cardImage ? (
            <img
              src={cardImage}
              alt="Generation preview"
              className={styles.recentProjectImage}
              loading="lazy"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
          ) : (
            <div className={styles.imagePlaceholder}>
              No Image
            </div>
          )}
        </div>
        
        <div className={styles.recentProjectDetails}>
          <div className={styles.recentProjectDetailsTop}>
            {isEditing ? (
              <div className={styles.editProjectNameContainer}>
                <div className={styles.editProjectNameInner}>
                  <input
                    type="text"
                    value={newProjectName}
                    onChange={(e) => setNewProjectName(e.target.value)}
                    className={`${styles.editProjectNameInput} ${newProjectName ? styles.editProjectNameInputFilled : ''}`}
                    placeholder="Enter project name"
                    maxLength={PROJECT_NAME_MAX_LENGTH}
                    autoFocus
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        onSaveProjectName(generationId);
                      } else if (e.key === 'Escape') {
                        onCancelEdit();
                      }
                    }}
                  />
                  <button
                    type="button"
                    className={styles.editProjectNameCloseBtn}
                    onClick={(e) => {
                      e.stopPropagation();
                      onCancelEdit();
                    }}
                    title="Close"
                    aria-label="Close"
                  >
                    <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 0.6125L6.3875 0L3.5 2.8875L0.6125 0L0 0.6125L2.8875 3.5L0 6.3875L0.6125 7L3.5 4.1125L6.3875 7L7 6.3875L4.1125 3.5L7 0.6125Z" fill="#505050"/>
                    </svg>
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div className={styles.cardTitleWithEdit}>
                  <div className={styles.cardTitle}>{currentProjectName}</div>
                  {onStartEdit && (
                    <button
                      type="button"
                      className={styles.editProjectNameBtn}
                      onClick={(e) => {
                        e.stopPropagation();
                        onStartEdit();
                      }}
                      title="Edit project name"
                      aria-label="Edit project name"
                    >
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.846 0.494806C13.5137 0.177226 13.0717 0 12.612 0C12.1524 0 11.7104 0.177226 11.3781 0.494806L10.1423 1.72879L5.02252 6.84859C4.7996 7.07259 4.64122 7.35257 4.56407 7.65903L4.055 9.69532C4.01173 9.86652 4.008 10.0453 4.04408 10.2182C4.08017 10.391 4.15512 10.5534 4.26327 10.693C4.37141 10.8326 4.50991 10.9458 4.66827 11.0239C4.82663 11.102 5.0007 11.1431 5.17728 11.144C5.27379 11.1439 5.36992 11.132 5.46352 11.1085L7.49981 10.5994C7.80661 10.5225 8.08674 10.3636 8.31025 10.1398L13.43 5.02001L14.6646 3.78602C14.9918 3.45871 15.1756 3.01485 15.1756 2.55203C15.1756 2.08922 14.9918 1.64535 14.6646 1.31805L13.846 0.494806ZM7.4905 9.31715C7.41603 9.39165 7.32272 9.44454 7.22055 9.47016L5.18426 9.97981L5.69391 7.94353C5.71928 7.84121 5.77196 7.7477 5.84635 7.673L10.5554 2.96453L12.2013 4.60984L7.4905 9.31715ZM13.846 2.96278L13.0222 3.78544L11.3763 2.14012L12.1995 1.31746C12.3103 1.21156 12.4576 1.15245 12.6109 1.15245C12.7641 1.15245 12.9115 1.21156 13.0222 1.31746L13.846 2.14012C13.9551 2.24923 14.0164 2.39718 14.0164 2.55145C14.0164 2.70572 13.9551 2.85368 13.846 2.96278Z" fill="#0752B0"/>
                      <path d="M2.90898 15.0876H11.0541C11.8253 15.0867 12.5647 14.7799 13.11 14.2346C13.6554 13.6892 13.9622 12.9498 13.9631 12.1786V6.71556C13.9631 6.56126 13.9018 6.41328 13.7927 6.30417C13.6836 6.19506 13.5356 6.13377 13.3813 6.13377C13.227 6.13377 13.079 6.19506 12.9699 6.30417C12.8608 6.41328 12.7995 6.56126 12.7995 6.71556V12.1786C12.7995 12.6415 12.6156 13.0855 12.2883 13.4128C11.961 13.7401 11.517 13.924 11.0541 13.924H2.90898C2.44607 13.924 2.00213 13.7401 1.6748 13.4128C1.34748 13.0855 1.16359 12.6415 1.16359 12.1786V4.03349C1.16359 3.57058 1.34748 3.12664 1.6748 2.79931C2.00213 2.47199 2.44607 2.2881 2.90898 2.2881H8.51748C8.67178 2.2881 8.81976 2.22681 8.92887 2.1177C9.03798 2.00859 9.09927 1.86061 9.09927 1.70631C9.09927 1.55201 9.03798 1.40402 8.92887 1.29492C8.81976 1.18581 8.67178 1.12451 8.51748 1.12451H2.90898C2.13775 1.12544 1.39838 1.43221 0.85304 1.97755C0.307701 2.52289 0.000923808 3.26226 0 4.03349V12.1786C0.000923808 12.9498 0.307701 13.6892 0.85304 14.2346C1.39838 14.7799 2.13775 15.0867 2.90898 15.0876Z" fill="#0752B0"/>
                      </svg>
                    </button>
                  )}
                </div>
                {listingMode && (
                  <div className={styles.recentProjectIdTag}>
                    <span>{listingMode}</span>
                  </div>
                )}
              </>
            )}
          </div>
          <div className={styles.cardDate}>
            {isDraft && (
              <>
                <span className={styles.recentProjectDraftBullet}>•</span>
                <span className={styles.recentProjectDraftText}>Draft</span>
                <span className={styles.recentProjectDateSeparator}>|</span>
              </>
            )}
            <span>{formatDate(generation.created_at)}</span>
          </div>
        </div>
      </div>
      <div className={styles.recentProjectScoreBadge}>
        <span>Single</span>
      </div>
    </div>
  );
};

export default SingleProjectCard;
